import { COURSE_RUN, COURSE_RUN_DEMAND } from '../reducer/course';
import request from '../request';

let getApiPath = (role, id) => `/manage/${role}/course-run-demands/${id ? id : ''}`;
// let getRoleName = () => JSON.parse(localStorage.getItem('permission'))?.role?.name;
// let roleName = getRoleName();

/**########################### Course run demand ###########################*/
export function courseRunDemandList(params = {}, selectedRole) {
  // if (roleName) roleName = getRoleName();

  //this server strategy in /option/ request response course_creator and in this request course-creator !!!
  if (selectedRole === 'course_creator') {
    selectedRole = 'course-creator';
  }

  return async function(dispatch) {
    try {
      dispatch({ type: COURSE_RUN_DEMAND.list.loading });

      let res = await request.get(getApiPath(selectedRole), { params: { ...params, status: 1 } });
      let { results, count } = res.data;

      dispatch({ type: COURSE_RUN_DEMAND.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: COURSE_RUN_DEMAND.list.error, payload: e.response.data });
    }
  };
}

/**########################### Course Original resource ###########################*/
export function courseRunList(params = {}, selectedRole) {
  // if (roleName) roleName = getRoleName();

  //this server strategy in /option/ request response course_creator and in this request course-creator !!!
  if (selectedRole === 'course_creator') {
    selectedRole = 'course-creator';
  }

  return async function(dispatch) {
    try {
      dispatch({ type: COURSE_RUN.list.loading });

      let res = await request.get(getApiPath(selectedRole), { params: { ...params, status__in: '2,3' } });
      let { results, count } = res.data;

      dispatch({ type: COURSE_RUN.list.get, payload: { results, count } });
    } catch (e) {
      dispatch({ type: COURSE_RUN.list.error, payload: e.response?.data });
    }
  };
}
